// Bilingual route mapping — French is the default language
const routeMap = {
  home: { fr: '/', en: '/' },
  services: { fr: '/services', en: '/services' },
  about: { fr: '/a-propos', en: '/about' },
  contact: { fr: '/contact', en: '/contact' },
  faq: { fr: '/faq', en: '/faq' },
  gallery: { fr: '/galerie', en: '/gallery' },
  book: { fr: '/rendez-vous', en: '/book' },
  privacy: { fr: '/confidentialite', en: '/privacy' },
  terms: { fr: '/conditions', en: '/terms' },
  login: { fr: '/connexion', en: '/login' },
  register: { fr: '/inscription', en: '/register' },
  dashboard: { fr: '/tableau-de-bord', en: '/dashboard' },
  admin: { fr: '/admin', en: '/admin' },
  'verify-email': { fr: '/verification-courriel', en: '/verify-email' },
  'set-password': { fr: '/definir-mot-de-passe', en: '/set-password' },
  'forgot-password': { fr: '/mot-de-passe-oublie', en: '/forgot-password' },
};

// Get localized path with lang prefix (e.g. /fr/services, /en/about)
function localizedPath(routeName, lang) {
  const route = routeMap[routeName];
  if (!route) return `/${lang}`;
  const suffix = route[lang];
  // Home route: just /{lang}
  if (suffix === '/') return `/${lang}`;
  return `/${lang}${suffix}`;
}

// Get the alternate language path for hreflang tags
function alternatePath(routeName, lang) {
  const altLang = lang === 'fr' ? 'en' : 'fr';
  return localizedPath(routeName, altLang);
}

// Find route name from a pathname (with or without lang prefix)
function findRouteFromPath(pathname) {
  // Strip lang prefix if present
  const match = pathname.match(/^\/(fr|en)(\/.*)?$/);
  if (!match) return null;
  const lang = match[1];
  const subPath = match[2] || '/';

  for (const [name, routes] of Object.entries(routeMap)) {
    if (routes[lang] === subPath) return name;
  }
  return null;
}

// Build all route patterns for React Router (used in App.js)
// Returns an array of { routeName, frPath, enPath } for registration
function getAllRoutePatterns() {
  return Object.entries(routeMap).map(([name, paths]) => ({
    routeName: name,
    frPath: paths.fr === '/' ? '/' : paths.fr.slice(1), // Remove leading /
    enPath: paths.en === '/' ? '/' : paths.en.slice(1),
  }));
}

export { routeMap, localizedPath, alternatePath, findRouteFromPath, getAllRoutePatterns };
